import routes from './routes';

export default [
  {
    name: 'Account',
    path: routes.ACCOUNT,
  },
  {
    name: 'Order History',
    path: routes.ORDER_HISTORY,
  },
  {
    name: 'Meal Planner',
    path: routes.PLANNER,
  },
  //   {
  //   name: 'Sign up',
  //   path: routes.SIGNUP,
  // },
  // {
  //   name: 'Log in',
  //   path: routes.LOGIN,
  // },
];
